var map = {
	"./agricultural_building.jpg": 7703,
	"./alcaldia.jpg": 3698,
	"./cadimun_1.jpg": 9572,
	"./casual_meeting.jpg": 8663,
	"./conferencia1.jpg": 9450,
	"./conferencia2.jpg": 6345,
	"./conferencia3.jpg": 4480,
	"./contact_image.jpg": 5667,
	"./cookies_image.jpg": 2704,
	"./credits_image.jpg": 4394,
	"./danny_photo.jpg": 2716,
	"./datarenta_1.jpg": 9459,
	"./education_image.jpg": 5968,
	"./environment_image.jpg": 8853,
	"./funec_1.jpg": 2637,
	"./funec_2.jpg": 6901,
	"./gobernacion_1.jpg": 2592,
	"./gobernacion_2.jpg": 7480,
	"./health_image.jpg": 8876,
	"./henry_ford.jpg": 9130,
	"./huella_ambiental_1.jpg": 1768,
	"./interoperabilidad_1.jpg": 6399,
	"./leonardo_dicaprio.jpg": 7393,
	"./logo_alcaldia_supia.jpg": 7545,
	"./logo_cda.jpg": 8082,
	"./logo_flores.jpg": 4675,
	"./logo_victoria.jpg": 6457,
	"./mah.jpg": 35,
	"./medicine_1.jpg": 7972,
	"./medicine_2.jpg": 2202,
	"./medicine_3.jpg": 7538,
	"./medicine_4.jpg": 1363,
	"./medicine_5.jpg": 7100,
	"./michael_jordan.jpg": 3037,
	"./nelson_mandela.jpg": 183,
	"./people_contact_1.jpg": 7582,
	"./people_joining_their_hands.jpg": 1918,
	"./photo_argemiro.jpg": 9060,
	"./photo_julian.jpg": 6739,
	"./photo_salome.jpg": 5289,
	"./regimen_image.jpg": 7296,
	"./registra_1.jpg": 4162,
	"./sport_1.jpg": 2384,
	"./sport_2.jpg": 1732,
	"./sport_3.jpg": 5391,
	"./sport_image.jpg": 7681,
	"./useterms_image.jpg": 3703,
	"./working_team.jpg": 4678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1810;